import { BrowserEnum } from '../type';

const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const getSubscription = async (vapidPublicKey: string): Promise<PushSubscription> => {
  if (typeof window === 'undefined' || !('navigator' in window)) {
    throw new Error('This function must be run in a browser environment');
  }
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service workers are not supported in this browser');
  }
  const registration = await navigator.serviceWorker.ready;
  if (!registration.active) {
    throw new Error('Service Worker is not active');
  }
  if (!registration.pushManager) {
    throw new Error('Push messaging is not supported');
  }
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: vapidPublicKey,
  });
  return subscription;
};

export const getSubscriptionInfo = async (vapidPublicKey: string) => {
  const subscription = await getSubscription(vapidPublicKey);
  const deviceId = subscription.endpoint.split('/').pop() || null;
  const p256dh = subscription.getKey('p256dh');
  const auth = subscription.getKey('auth');
  if (!deviceId || !p256dh || !auth) {
    throw new Error('Failed to retrieve subscription information');
  }
  const data = {
    deviceId,
    p256dh: arrayBufferToBase64(p256dh),
    auth: arrayBufferToBase64(auth),
    endpoint: subscription.endpoint,
    expirationTime: subscription.expirationTime,
  };
  return data;
};

export const getBrowserName = (): BrowserEnum => {
  const { userAgent } = navigator;
  if (/Edg/.test(userAgent)) return BrowserEnum.EDGE;
  if (/Firefox/.test(userAgent)) return BrowserEnum.FIREFOX;
  if (/Chrome/.test(userAgent)) return BrowserEnum.CHROME;
  if (/Safari/.test(userAgent)) return BrowserEnum.SAFARI;
  return BrowserEnum.CHROME;
};
